// Language modal logic extracted from header.js
export function showLanguageModal() {
    const langModalShown = localStorage.getItem('langModalShown');

    if (langModalShown) {
        return;
    }

    setTimeout(() => {
        if (window.fgtModalOpen) return; // Don't show if another modal is open

        const langModal = document.getElementById('fgt-lang-modal');
        const availableLanguages = JSON.parse(langModal.getAttribute('data-available-languages'));
        const currentLang = langModal.getAttribute('data-current-language');
        const userLangs = navigator.languages || [navigator.language];

        const matchedLang = userLangs.find(lang => availableLanguages.includes(lang.split('-')[0]));

        if (matchedLang && matchedLang.split('-')[0] !== currentLang) {
            langModal.classList.remove('hidden');
            localStorage.setItem('langModalShown', 'true');
            window.fgtModalOpen = true; // Set global modal open flag
        }
    }, 5000); // Delay for 5 seconds
}
